import React, { useMemo } from 'react'
import TrackedCardCarousel from 'components/Common/TrackedCardCarousel'
import PaneBody from 'components/Common/Pane/PaneBody'
import Pane from 'components/Common/Pane'
import Heading from 'components/Luxkit/Typography/Heading'
import useOffers from 'hooks/Offers/useOffers'
import StandaloneLocationSeededYmalListOffer, { CARD_WIDTH } from './StandaloneLocationSeededYmalListOffer'
import { useLereNearbyOffers } from 'hooks/Recommendation/useLereNearbyOffers'
import CarouselCardLoadingSkeleton from 'components/OfferList/OfferCards/CarouselCardLoadingSkeleton'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { without } from 'lib/array/arrayUtils'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

const LoadingCard = styled(CarouselCardLoadingSkeleton)`
  width: 75vw;
  ${mediaQueryUp.tablet} {
    width: ${rem(CARD_WIDTH)};
  }
  min-height: ${rem(400)};
`

interface Props {
  destinationId: string;
  excludeOfferIds: Array<string>;
  analyticPageSource: string;
}

function StandaloneLocationSeededYmalList(props: Props) {
  const { destinationId, excludeOfferIds } = props

  const validDestination = destinationId.startsWith('le_')
  const lereNearbyOffers = useLereNearbyOffers(validDestination, destinationId)
  const offerIds = useMemo(() => {
    const lereIds = lereNearbyOffers?.offers?.map(offer => offer.offerId) ?? []
    return without(lereIds, ...excludeOfferIds)
  }, [lereNearbyOffers, excludeOfferIds])

  const [offers, offersFetching] = useOffers<App.Offer>(offerIds)

  const isLoading = !lereNearbyOffers || lereNearbyOffers.state === 'loading' || offersFetching

  if (!validDestination || (!isLoading && offers.length === 0)) {
    return null
  }

  return (
    <Pane>
      <PaneBody size="xl-y">
        <VerticalSpacer gap={16}>
          <Heading variant="heading3">You may also like</Heading>
          <TrackedCardCarousel pageSize={4}>
            {isLoading &&
              <>
                <LoadingCard />
                <LoadingCard />
                <LoadingCard />
                <LoadingCard />
              </>
              }
            {offers.map((offer, index) => <StandaloneLocationSeededYmalListOffer key={offer.id} offer={offer} position={index}/>)}
          </TrackedCardCarousel>
        </VerticalSpacer>
      </PaneBody>
    </Pane>
  )
}

export default StandaloneLocationSeededYmalList
